// apps/client/src/hooks/useBreadcrumbs.ts
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface Breadcrumb {
  label: string;
  href:  string;
}

const ROUTE_LABEL_MAP: Record<string, string> = {
  dashboard:         'Dashboard',
  orders:            'Orders',
  new:               'New Order',
  shipments:         'Shipments',
  'lorry-receipts':  'Lorry Receipts',
  invoices:          'Invoices',
  payments:          'Payments',
  documents:         'Documents',
  support:           'Support',
  profile:           'Profile',
  settings:          'Settings',
  tracking:          'Track Shipment',
  notifications:     'Notifications',
};

export function useBreadcrumbs(): Breadcrumb[] {
  const { pathname } = useLocation();

  return useMemo(() => {
    const segments = pathname.split('/').filter(Boolean);
    const crumbs: Breadcrumb[] = [];
    let path = '';

    segments.forEach((segment) => {
      path += `/${segment}`;
      const label = ROUTE_LABEL_MAP[segment];

      if (label) {
        crumbs.push({ label, href: path });
      } else if (/^[0-9a-f-]{36}$/i.test(segment)) {
        crumbs.push({ label: 'Details', href: path });
      } else {
        crumbs.push({
          label: segment.charAt(0).toUpperCase() + segment.slice(1),
          href:  path,
        });
      }
    });

    return crumbs;
  }, [pathname]);
}

// Day 14 complete
